import { Icon, LinkButton } from '@saas/ui';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-5 py-16 text-center">
      <Icon name="search" size={28} className="text-fg-tertiary" />
      <h1 className="font-serif text-title">ページが見つかりません</h1>
      <p className="text-callout text-fg-secondary">URL が間違っているか、削除された可能性があります。</p>
      <div className="mt-4">
        <LinkButton to="/" variant="secondary" icon="home">
          自分宛てへ戻る
        </LinkButton>
      </div>
    </div>
  );
}
